var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.Order.Messages.SubmitRequestOrderChange, Vendd.Order, function (envelope) {   
        function onSuccess(response) {
            if (response.success === true) {
                Vendd.MessageBus.publishAsync(Vendd.Order, new Vendd.Order.Messages.SubmitRequestOrderChangeSuccess(response));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.Order, new Vendd.Order.Messages.SubmitRequestOrderChangeFailure(response));
            }
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Order, new Vendd.Order.Messages.SubmitRequestOrderChangeFailure(response));
        };

        var options = {
            url: 'AuthService.svc/RequestOrderChange',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Order.Messages.CancelUncompletedOrder, Vendd.Order, function (envelope) {
            function onSuccess(response) {
                if (response.success) {
                    Vendd.MessageBus.publishAsync(Vendd.Order, new Vendd.Order.Messages.CancelUncompletedOrderSuccess(response));
                } else {
                    Vendd.MessageBus.publishAsync(Vendd.Order, new Vendd.Order.Messages.CancelUncompletedOrderFailed(response));
                };
            }

            function onFailure(response) {
                Vendd.MessageBus.publishAsync(Vendd.Order, new Vendd.Order.Messages.CancelUncompletedOrderFailed(response));
            }

            var options = {
                url: 'EcomService.svc/CancelUncompletedOrder',
                data: {
                    orderId: envelope.message.data.orderId
                },
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            Vendd.Service.call(options);
        });

    Vendd.MessageBus.subscribe(Vendd.Order.Messages.ReturnOrderItem, Vendd.Order, function (envelope) {
            function onSuccess(response) {
                if (response.success) {
                    Vendd.MessageBus.publishAsync(Vendd.Order, new Vendd.Order.Messages.ReturnOrderItemSuccess(response));
                } else {
                    Vendd.MessageBus.publishAsync(Vendd.Order, new Vendd.Order.Messages.ReturnOrderItemFailed(response));
                };
            }

            function onFailure(response) {
                Vendd.MessageBus.publishAsync(Vendd.Order, new Vendd.Order.Messages.ReturnOrderItemFailed(response));
            }

            var options = {
                url: 'EcomService.svc/ReturnOrderItem',
                data: {
                    orderItemId: envelope.message.data.orderItemId
                },
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            Vendd.Service.call(options);
        });

    return Vendd;

})(Vendd || {});